// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:54:41.995Z
// Property: Stanford Heights (ID: 6767906449166908)
// Collections: 26 amenities, 9 floorplans (live), 32 photos, 37 POIs, 4 reviews, 11 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166908",
  "property_external_id": "495835",
  "property_zillow_url": "https://www.zillow.com/homedetails/5801-Little-Rock-Rd-Rocklin-CA-95765/188075648_zpid/",
  "property_apartments_url": "https://www.apartments.com/stanford-heights-rocklin-ca/9gxt395/",
  "property_google_business_url": "https://www.google.com/maps/place/Stanford+Heights+Apartments/data=!4m2!3m1!1s0x0:0xa30b50379274cda6?sa=X&ved=2ahUKEwj64IKXmbySAxX2nCYFHYBEBG0Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495835 p0505503",
  "property_status": null,
  "property_slug": "stanford-heights",
  "property_name": "Stanford Heights",
  "property_website_url": "http://www.rocklin-apartments.net/",
  "property_domain": "https://www.rocklin-apartments.net/",
  "property_address": "5801 Little Rock Road",
  "property_full_address": "5801 Little Rock Rd, Rocklin, CA 95765",
  "property_address_1": "5801 Little Rock Road",
  "property_address_2": null,
  "property_address_city": "Rocklin",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95765",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "Outer Roseville/Rocklin",
  "property_address_latitude": "38.8008138",
  "property_address_longitude": "-121.270151",
  "property_email": "stanfordheights@ctlmanagement.com",
  "property_phone": "(279) 300-0750",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Stanford Heights in Rocklin, CA, your perfect home awaits! Choose from elegantly designed one, two, or three-bedroom floor plans. Enjoy top-tier amenities, including a sparkling pool, fitness center, and dog park. Embrace community living with planned social events and unwind at our movie theater. Find your new home today!",
  "property_long_description": "Welcome to Stanford Heights, a premier apartment community nestled in the heart of Rocklin, CA. Our thoughtfully designed floor plans offer a perfect blend of comfort and convenience, featuring spacious one, two, and three-bedroom apartments that cater to your lifestyle needs. Each home includes modern amenities such as a washer/dryer, air conditioning, and a fully equipped kitchen with a dishwasher and refrigerator.\n\nAt Stanford Heights, we prioritize your leisure and well-being with an array of exceptional amenities. Dive into relaxation at our sparkling pool, stay active in our state-of-the-art fitness center, or unwind in our luxurious spa. Gather with friends at the clubhouse or enjoy a movie night in our media center. With planned social activities and a vibrant community atmosphere, you'll find plenty of opportunities to connect and engage.\n\nFor pet lovers, our dog park ensures your furry friends have a space to roam and play. Our property is designed for accessibility, offering wheelchair-friendly options and ample storage space. Enjoy the perks of high-speed internet access and online services, making your living experience seamless.\n\nLocated in picturesque Rocklin, Stanford Heights places you close to shopping, dining, and outdoor activities, all while providing a peaceful retreat you can call home. With features like vaulted ceilings, balconies, and patios, your apartment will be a sanctuary of comfort.\n\nFind your new home today at Stanford Heights—browse our availability or schedule a tour to visit our vibrant community! Experience a lifestyle of comfort, convenience, and connection.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-6740-73b4-a006-a8914c0b64e4.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior building entrance with stone walkway and lush landscaping.",
    "public_id": "019d08b1-6740-73b4-a006-a8914c0b64e4",
    "storage_key": "property/6767906449166908/019d08b1-6740-73b4-a006-a8914c0b64e4.webp",
    "width": 2048,
    "height": 1367
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "170",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.6470588235294",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "$500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://rocklin-apts.securecafe.com/onlineleasing/stanford-heights-0/guestlogin",
  "property_resident_portal_url": "https://rocklin-apts.securecafenet.com/residentservices/stanford-heights-0/userlogin",
  "property_apply_now_url": "https://rocklin-apartments.securecafe.com/onlineleasing/stanford-heights-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d740c-85ff-723b-b03c-ab20e12a93cc.webp",
  "property_primary_logo_media": {
    "alt_text": "Stanford Heights Apartments logo.",
    "public_id": "019d740c-85ff-723b-b03c-ab20e12a93cc",
    "storage_key": "property/6767906449166908/019d740c-85ff-723b-b03c-ab20e12a93cc.webp",
    "width": 812,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d740c-85ff-723b-b03c-afdc4d862569.webp",
  "property_secondary_logo_media": {
    "alt_text": "Stanford Heights Apartments logo",
    "public_id": "019d740c-85ff-723b-b03c-afdc4d862569",
    "storage_key": "property/6767906449166908/019d740c-85ff-723b-b03c-afdc4d862569.webp",
    "width": 807,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019de0b2-5482-71bd-910e-d85c41342807.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Empty image with a white horizontal band in the middle.",
    "public_id": "019de0b2-5482-71bd-910e-d85c41342807",
    "storage_key": "property/6767906449166908/019de0b2-5482-71bd-910e-d85c41342807.webp",
    "width": 812,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019de0b2-47f8-7602-9a24-c6db819b2fb2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black stripe",
    "public_id": "019de0b2-47f8-7602-9a24-c6db819b2fb2",
    "storage_key": "property/6767906449166908/019de0b2-47f8-7602-9a24-c6db819b2fb2.webp",
    "width": 812,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "623 - 985",
  "property_sqft_min": "623",
  "property_sqft_max": "985",
  "property_price_range": "1800 - 2950",
  "property_price_min": "1800",
  "property_price_max": "2950",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/stanfordheightsapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJuYUHufghm4ARps10kjdQC6M",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Rocklin%2C+CA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stanford Heights",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Stanford Heights, where luxurious living meets vibrant community life in Rocklin, CA. Choose from our stylish one, two, or three-bedroom floor plans, and indulge in exceptional amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing spa. Join us for social activities and start your next chapter today!",
  "property_home_floorplans_blurb": "Welcome to Stanford Heights in Rocklin, CA, where modern living meets serene surroundings. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious layouts and contemporary finishes. Step inside and envision your future—browse our available apartment homes today to find the perfect fit for your unique needs!",
  "property_home_gallery_blurb": "At Stanford Heights in Rocklin, CA, you’ll find elegantly designed one, two, and three-bedroom apartments tailored for your lifestyle. Enjoy resort-style amenities like a refreshing pool, a state-of-the-art fitness center, and vibrant social activities—all just steps from your door. Picture yourself living here, where comfort meets community!",
  "property_home_neighborhood_blurb": "Welcome to Stanford Heights in Rocklin, CA, where vibrant living meets a wealth of nearby attractions. Enjoy adventures at Sierra College Natural History Museum or unwind at Maidu Regional Park. With easy access to fitness centers and shopping at Westfield Galleria, your ideal lifestyle awaits—come see what’s around!",
  "property_home_reviews_blurb": "Nestled in the heart of Rocklin, CA, Stanford Heights offers an inviting atmosphere that residents adore. As one happy tenant shares, “The community is friendly, and the amenities are top-notch.\" Dive into our reviews and see what makes living here a cherished experience for many!",
  "property_neighborhood_blurb": "At Stanford Heights in Rocklin, CA, vibrant living meets endless adventure. With Sierra College and the Maidu Museum nearby, knowledge and culture thrive. Parks like Johnson-Springview and Mahany invite outdoor enjoyment, while the Westfield Galleria offers shopping and entertainment. Experience dynamic community life filled with local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Stanford Heights in Rocklin, CA, our thoughtfully designed one, two, and three-bedroom apartments offer a blend of comfort and style. Enjoy luxurious amenities like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Embrace a vibrant lifestyle with social activities, a dog park, and a movie theater right at home!",
  "property_applynow_blurb": "At Stanford Heights in Rocklin, CA, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy a vibrant lifestyle with amenities like a refreshing pool, state-of-the-art fitness center, and a serene dog park. Ready to make Stanford Heights your new home? Lease online today!",
  "property_contactus_blurb": "At Stanford Heights in Rocklin, CA, we offer an array of thoughtfully designed floor plans, including one, two, and three-bedroom apartments tailored to fit your lifestyle. Our leasing team is eager to assist you—reach out today with any questions about your future home!",
  "property_faqs_blurb": "At Stanford Heights in Rocklin, CA, we offer diverse floor plans, from cozy one-bedroom to spacious three-bedroom apartments. Curious about our community? Our FAQs page is the perfect resource to answer all your burning questions and help you envision your future home with us. Visit now to learn more!",
  "property_floorplans_blurb": "At Stanford Heights in Rocklin, CA, find your ideal living space among our thoughtfully designed floor plans. Choose from cozy one-bedroom, spacious two-bedroom, or versatile three-bedroom layouts tailored to fit your lifestyle. Browse our available apartment homes today and envision your next chapter in comfort and style!",
  "property_gallery_blurb": "At Stanford Heights in Rocklin, CA, each spacious floor plan—from one to three bedrooms—offers modern comforts and a vibrant lifestyle. Picture yourself lounging by the pool, unwinding in the spa, or enjoying engaging social activities. Create unforgettable memories with us—your dream home awaits, complete with amenities for every lifestyle.",
  "property_interactivemap_blurb": "At Stanford Heights in Rocklin, CA, your perfect apartment awaits—whether it’s a cozy one-bedroom or a spacious three-bedroom. Enjoy enticing amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing spa. Utilize our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Stanford Heights in Rocklin, CA, your furry companions will thrive! Our pet-friendly community warmly welcomes indoor adult cats and small dogs under 25 lb. Delight in the freedom of shared spaces, while enjoying the joy of your two pets per unit. Make your home a haven for all creatures, big and small!",
  "property_referafriend_blurb": "At Stanford Heights in Rocklin, CA, inviting floor plans await, from cozy one-bedroom retreats to spacious three-bedroom havens designed for modern living. Share the joy of community with your friends—refer someone today and enjoy the benefits of having great neighbors just a heartbeat away!",
  "property_residentaccess_blurb": "At Stanford Heights in Rocklin, CA, your ideal living space is just a click away. Choose from thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Want convenience at your fingertips? Access your resident portal to effortlessly manage rent, maintenance requests, and more!",
  "property_reviews_blurb": "At Stanford Heights in Rocklin, CA, residents rave about the vibrant community atmosphere and exceptional amenities. One delighted tenant shared, “Living here feels like home!” Dive into our reviews to experience firsthand the joy of apartment living at Stanford Heights. See what our residents have to say about living at our community!",
  "property_created_at": "1762785143099",
  "property_scheduletour_blurb": "At Stanford Heights in Rocklin, CA, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Experience a vibrant community where comfort meets convenience. Curious about life here? Schedule a tour today and hear firsthand from our residents about their wonderful experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Stanford Heights in Rocklin, CA! We offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments to suit your lifestyle. Our team will be in touch soon to help you find your perfect home nestled in a vibrant community!",
  "property_virtualtours_blurb": "Welcome to Stanford Heights in Rocklin, CA, where comfort meets sophistication. Choose from our inviting one, two, or three-bedroom floor plans designed to suit your lifestyle. Ready for an inside look? Experience the warmth of home by taking a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Stanford Heights",
  "property_seo_title_home": "Stanford Heights |  Apartments in Rocklin, CA",
  "property_seo_description_home": "Discover vibrant living at Stanford Heights, Rocklin! Choose from spacious 1, 2, or 3-bedroom apartments with great amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Rocklin, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Stanford Heights in Rocklin, CA! From cozy one-beds to spacious three-beds, browse our unique floor plans and make it yours.",
  "property_seo_title_amenities": "Amenities | Rocklin, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience Stanford Heights in Rocklin, CA! Enjoy luxury living with a pool, fitness center, and pet-friendly amenities. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Rocklin, CA",
  "property_seo_description_gallery": "Unwind at Stanford Heights in Rocklin, CA! Dive into our vibrant community with stunning pools, a fitness center, and a dog park. Picture your new life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Stanford Heights Apartments",
  "property_seo_description_virtualtours": "Experience Stanford Heights in Rocklin, CA! Take a virtual tour of our inviting one, two, and three-bedroom apartments, and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Stanford Heights Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Stanford Heights in Rocklin, CA! Use our interactive map to explore spacious apartments with amenities from a pool to a dog park.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rocklin, CA",
  "property_seo_description_neighborhood": "Uncover the charm of Rocklin, CA! At Stanford Heights, dive into a vibrant neighborhood filled with local favorites and attractions just steps from your door.",
  "property_seo_title_contact": "Contact Us | Stanford Heights",
  "property_seo_description_contact": "Discover your ideal home at Stanford Heights, Rocklin, CA. With 1, 2, and 3-bedroom options, our leasing team is here to help—contact us now!",
  "property_seo_title_faqs": "FAQs | Apartments in Rocklin, CA",
  "property_seo_description_faqs": "Find answers to your questions about Stanford Heights in Rocklin, CA! From floor plans to amenities, get all the info you need for your next home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rocklin, CA",
  "property_seo_description_reviews": "Discover Stanford Heights in Rocklin, CA! Enjoy spacious floor plans, a pool, fitness center, and dog park that residents love.",
  "property_seo_title_applynow": "Apply Now | Apartments in Rocklin, CA",
  "property_seo_description_applynow": "Elevate your lifestyle at Stanford Heights in Rocklin, CA. Enjoy a pool, gym, dog park, and more. Apply online and secure your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Stanford Heights",
  "property_seo_description_residentaccess": "Login to Stanford Heights' resident portal! Seamlessly pay rent, schedule maintenance, and access community news—all from your cozy corner in Rocklin, CA.",
  "property_seo_title_referafriend": "Refer A Friend | Stanford Heights",
  "property_seo_description_referafriend": "Invite your friends to Stanford Heights in Rocklin, CA! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Stanford Heights",
  "property_seo_description_scheduletour": "Experience luxe living at Stanford Heights in Rocklin, CA. Schedule a tour today and see your future home nestled in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Stanford Heights",
  "property_seo_description_privacy": "At Stanford Heights in Rocklin, CA, your privacy matters. Learn how we protect your information and ensure a secure living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Stanford Heights",
  "property_seo_description_accessibility": "Experience seamless living at Stanford Heights in Rocklin, CA. Join our inclusive community where accessibility ensures everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Stanford Heights",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Stanford Heights! Check out our sitemap for a clear path to luxury apartments in Rocklin, CA.",
  "property_seo_title_thankyou": "Thank You | Stanford Heights",
  "property_seo_description_thankyou": "Thank you for reaching out to Stanford Heights in Rocklin, CA! Our team will connect with you soon to help you find your perfect apartment home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Rocklin, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874947464",
  "amenities": [
    {
      "id": "ec_23f2817a30a1868c643ce115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429472",
      "title": "Clubhouse With Complimentary WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-bf26-7403-b62e-aa8642f33795.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a marble-top dining table, leather sofas, and a fireplace.",
        "public_id": "019d4a38-bf26-7403-b62e-aa8642f33795",
        "storage_key": "property/6767906449166908/019d4a38-bf26-7403-b62e-aa8642f33795.webp",
        "width": 3072,
        "height": 2053
      },
      "amenity_image_alt_text": "Stanford Heights clubhouse fireplace and seating",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65db81d1b96da58db3bd9e7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429471",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-3fb0-704a-8db1-983c30b3bf9a.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers, printer, and desks.",
        "public_id": "019d4a39-3fb0-704a-8db1-983c30b3bf9a",
        "storage_key": "property/6767906449166908/019d4a39-3fb0-704a-8db1-983c30b3bf9a.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Stanford Heights business center computers",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13bb5c7bc846949e54d59598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429479",
      "title": "Theater Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f413a1aa83a82126406559f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429468",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f973-7113-927e-d5409c516d69.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with weight machines, free weights, exercise balls, and cardio equipment.",
        "public_id": "019d4a39-f973-7113-927e-d5409c516d69",
        "storage_key": "property/6767906449166908/019d4a39-f973-7113-927e-d5409c516d69.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Stanford Heights fitness center and equipment,Stanford Heights strength training equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b07ff64c55c29d81f9460b41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429477",
      "title": "Indoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-70e8-727f-ac09-8abefdad6860.webp",
      "amenity_image_media": {
        "alt_text": "Hot tub with bubbling water and safety signs.",
        "public_id": "019d4a39-70e8-727f-ac09-8abefdad6860",
        "storage_key": "property/6767906449166908/019d4a39-70e8-727f-ac09-8abefdad6860.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Stanford Heights Indoor Spa",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_849654948d29da6dbb6b8584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429478",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f970-713d-9ea1-5f382234c38f.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d4a39-f970-713d-9ea1-5f382234c38f",
        "storage_key": "property/6767906449166908/019d4a39-f970-713d-9ea1-5f382234c38f.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Stanford Heights swimming pool side view,Stanford Heights swimming pool entry view,Stanford Heights swimming pool and furniture",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76fd92e7afba3c5362167e40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429470",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ff78291cd7f14d282e9fa96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457975",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cdbc21350550c872bd8bd72f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429480",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f6c5-7240-b306-a0609c7aaed4.webp",
      "amenity_image_media": {
        "alt_text": "Dog park area with agility equipment including a tunnel and ramp.",
        "public_id": "019d4a3a-f6c5-7240-b306-a0609c7aaed4",
        "storage_key": "property/6767906449166908/019d4a3a-f6c5-7240-b306-a0609c7aaed4.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Stanford Heights bark park interior",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d33176d9fda7f1d0525d049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457977",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4f225124839ecc48af9fe7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457976",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3c-0c24-72ab-802c-a452546db48f.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a building with multiple white garage doors.",
        "public_id": "019d4a3c-0c24-72ab-802c-a452546db48f",
        "storage_key": "property/6767906449166908/019d4a3c-0c24-72ab-802c-a452546db48f.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "a row of garages with white garage doors",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b3a71a9a8f9bdefebaf364e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457974",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_963da0373666c09cf42c61d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429476",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a881f82171a1842770e76125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457978",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e96d637161f9ed945f7f0ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "82390274",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da52a64ebeccf9a84272d219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "82390276",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3fe2710cbbf30947f1fd1be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "86457979",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a4f89882bf9a148f238339e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429486",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32dc899335d31ca2d65e4f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429484",
      "title": "Central Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d5b9ae78568325d297f8567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429487",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed445d93a3bf282097cdd9ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429483",
      "title": "Ample Closet Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_279b9efe4516598883849e60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429488",
      "title": "Vaulted Ceilings - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaeb89d1a96ed105793642cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429481",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c48717e0c1d4dd80857473a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80429485",
      "title": "Cottages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5aa5569db62fd5e4d8202e69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "80683701",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb5cf03bf742fb58d2ed778c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "yardi",
      "external_id": "87311309",
      "title": "Ceiling Fan - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1d9242fa288cacbaae1f450a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d42ab-e6bd-7014-af0f-c07607e5b423.webp",
      "image_media": {
        "alt_text": "Kitchen with white stove, refrigerator, sink, and light wood cabinets.",
        "public_id": "019d42ab-e6bd-7014-af0f-c07607e5b423",
        "storage_key": "property/6767906449166908/019d42ab-e6bd-7014-af0f-c07607e5b423.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring a white stove, refrigerator, stainless steel sink, and ample light wood cabinetry. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white stove, refrigerator, sink, and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelKitchenLaundry.jpg"
    },
    {
      "id": "ec_8609602e251a4d2555f0ea24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4977-6be7-73a6-beb4-bff7c40ed831.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area in an apartment.",
        "public_id": "019d4977-6be7-73a6-beb4-bff7c40ed831",
        "storage_key": "property/6767906449166908/019d4977-6be7-73a6-beb4-bff7c40ed831.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen and dining area with light wood cabinets, granite countertops, and a round dining table with four chairs.",
      "link": "false",
      "alt_text": "Kitchen and dining area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_17b289c1ed919263e58aa497",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4977-9bfa-76ae-a8eb-690a255431e0.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white appliances, light wood cabinets, and beige walls.",
        "public_id": "019d4977-9bfa-76ae-a8eb-690a255431e0",
        "storage_key": "property/6767906449166908/019d4977-9bfa-76ae-a8eb-690a255431e0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This image shows a dining area with a round table and chairs, adjacent to a kitchen featuring white appliances, light wood cabinetry, and a tiled floor.",
      "link": "false",
      "alt_text": "Dining area and kitchen with white appliances, light wood cabinets, and beige walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelDiningRoom.jpg"
    },
    {
      "id": "ec_ae514b652d6a853ffdacaf49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4977-6b85-723f-a51c-bfc7ab9f69ee.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, open to a kitchen with a breakfast bar and stools.",
        "public_id": "019d4977-6b85-723f-a51c-bfc7ab9f69ee",
        "storage_key": "property/6767906449166908/019d4977-6b85-723f-a51c-bfc7ab9f69ee.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy meals and entertaining in this spacious dining area, complete with a breakfast bar overlooking the kitchen.",
      "link": "false",
      "alt_text": "Dining area with a round table and chairs, open to a kitchen with a breakfast bar and stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelDiningRoomBreakfastBar.jpg"
    },
    {
      "id": "ec_6f76b3a2b28c713c098d7af2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4977-6d1f-7061-86d2-e0ecb530d1e5.webp",
      "image_media": {
        "alt_text": "Living room with sofa, accent chairs, coffee table, and balcony access.",
        "public_id": "019d4977-6d1f-7061-86d2-e0ecb530d1e5",
        "storage_key": "property/6767906449166908/019d4977-6d1f-7061-86d2-e0ecb530d1e5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring comfortable seating, a unique coffee table, and access to your private balcony.",
      "link": "false",
      "alt_text": "Living room with sofa, accent chairs, coffee table, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelLivingRoom1.jpg"
    },
    {
      "id": "ec_eaf0d811e347f943850a6f3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4977-6c4d-75cb-a4c5-dc8155ee7461.webp",
      "image_media": {
        "alt_text": "Cozy living room with a couch, two chairs, a coffee table, and a large abstract painting.",
        "public_id": "019d4977-6c4d-75cb-a4c5-dc8155ee7461",
        "storage_key": "property/6767906449166908/019d4977-6c4d-75cb-a4c5-dc8155ee7461.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living room, perfect for unwinding or entertaining guests. Featuring plush seating and tasteful decor.",
      "link": "false",
      "alt_text": "Cozy living room with a couch, two chairs, a coffee table, and a large abstract painting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelLivingRoom2.jpg"
    },
    {
      "id": "ec_818cb88d0765375bc94d098c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4981-a0f1-735e-ad66-7b16e3b007c2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and closet.",
        "public_id": "019d4981-a0f1-735e-ad66-7b16e3b007c2",
        "storage_key": "property/6767906449166908/019d4981-a0f1-735e-ad66-7b16e3b007c2.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush queen-size bed, ample storage, and a large closet.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_c51bd30f84b5476b42504275",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4981-a239-731e-8e13-bbae4fdeb4c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand with lamps, and closet space. A bathroom is visible through an open doorway.",
        "public_id": "019d4981-a239-731e-8e13-bbae4fdeb4c3",
        "storage_key": "property/6767906449166908/019d4981-a239-731e-8e13-bbae4fdeb4c3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, elegant nightstands with lamps, ample closet space, and an en-suite bathroom for added convenience.",
      "link": "false",
      "alt_text": "Bedroom with a bed, nightstand with lamps, and closet space. A bathroom is visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelPrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_d3e63a5b80340c92e8fb3cfb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4981-a0fd-7784-9af6-c36c9a6e526a.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with a white tub, shower, toilet, and vanity with a mirror.",
        "public_id": "019d4981-a0fd-7784-9af6-c36c9a6e526a",
        "storage_key": "property/6767906449166908/019d4981-a0fd-7784-9af6-c36c9a6e526a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into a clean and bright bathroom featuring a spacious bathtub, a modern vanity with ample counter space, and a large mirror. Perfect for relaxing after a long day.",
      "link": "false",
      "alt_text": "Clean and modern bathroom with a white tub, shower, toilet, and vanity with a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelPrimaryBathroom.jpg"
    },
    {
      "id": "ec_46b7816975a48dc4ecea66b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4981-a0f4-72b0-beca-7068b8bfda48.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "019d4981-a0f4-72b0-beca-7068b8bfda48",
        "storage_key": "property/6767906449166908/019d4981-a0f4-72b0-beca-7068b8bfda48.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant dresser, and ample closet space for all your storage needs.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_9412dbf3734ec94c7cbbde2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4981-a0f7-7739-ae5d-472894faf944.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019d4981-a0f7-7739-ae5d-472894faf944",
        "storage_key": "property/6767906449166908/019d4981-a0f7-7739-ae5d-472894faf944.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This bathroom features a vanity with a sink and ample counter space, a toilet, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ModelMainBathroom.jpg"
    },
    {
      "id": "ec_5b345268396d01a99cc9c2ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-b950-717a-bce0-c73887d4ff56.webp",
      "image_media": {
        "alt_text": "Stanford Heights apartment community monument sign with waterfall and landscaping.",
        "public_id": "019d4a38-b950-717a-bce0-c73887d4ff56",
        "storage_key": "property/6767906449166908/019d4a38-b950-717a-bce0-c73887d4ff56.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to Stanford Heights, a Randall Apartment Community, featuring a beautiful monument sign with a cascading waterfall and lush floral landscaping.",
      "link": "false",
      "alt_text": "Stanford Heights apartment community monument sign with waterfall and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_Monument1.jpg"
    },
    {
      "id": "ec_75c28f313186c642ca92b7a3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-b6f7-7726-8e7f-ed5b3943a9cc.webp",
      "image_media": {
        "alt_text": "Entrance to apartment building with pathway and decorative stone walls.",
        "public_id": "019d4a38-b6f7-7726-8e7f-ed5b3943a9cc",
        "storage_key": "property/6767906449166908/019d4a38-b6f7-7726-8e7f-ed5b3943a9cc.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Charming pathway leading to the entrance of the apartment community, framed by lush greenery and flowering trees.",
      "link": "false",
      "alt_text": "Entrance to apartment building with pathway and decorative stone walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ClubhouseEntryBridge(3).jpg"
    },
    {
      "id": "ec_b8237487560c79f0b99f244f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-b6fb-7524-b119-909b5c2703fd.webp",
      "image_media": {
        "alt_text": "Manicured landscaping with a pond and small waterfall in front of apartment building entrance.",
        "public_id": "019d4a38-b6fb-7524-b119-909b5c2703fd",
        "storage_key": "property/6767906449166908/019d4a38-b6fb-7524-b119-909b5c2703fd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds featuring a serene pond and cascading waterfall, creating a peaceful ambiance at the apartment community entrance.",
      "link": "false",
      "alt_text": "Manicured landscaping with a pond and small waterfall in front of apartment building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ClubhouseEntryFountain.jpg"
    },
    {
      "id": "ec_ead8d4836ffbad744a726b07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-b630-7404-877a-8e0077f6e669.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with seating and a decorative sculpture.",
        "public_id": "019d4a38-b630-7404-877a-8e0077f6e669",
        "storage_key": "property/6767906449166908/019d4a38-b630-7404-877a-8e0077f6e669.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable clubhouse lounge, featuring stylish seating and a unique artistic centerpiece.",
      "link": "false",
      "alt_text": "Clubhouse lounge area with seating and a decorative sculpture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ClubhouseFoyer.jpg"
    },
    {
      "id": "ec_ab00018ae84d1273085f85f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a38-bf26-7403-b62e-aa8642f33795.webp",
      "image_media": {
        "alt_text": "Community lounge area with a marble-top dining table, leather sofas, and a fireplace.",
        "public_id": "019d4a38-bf26-7403-b62e-aa8642f33795",
        "storage_key": "property/6767906449166908/019d4a38-bf26-7403-b62e-aa8642f33795.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a cozy fireplace, and a spacious dining area perfect for gatherings.",
      "link": "false",
      "alt_text": "Community lounge area with a marble-top dining table, leather sofas, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_ClubhouseFireplaceSeating.jpg"
    },
    {
      "id": "ec_a62c803bd25286a4c8bc452d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-3fb0-704a-8db1-983c30b3bf9a.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and desks.",
        "public_id": "019d4a39-3fb0-704a-8db1-983c30b3bf9a",
        "storage_key": "property/6767906449166908/019d4a39-3fb0-704a-8db1-983c30b3bf9a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay productive in our well-equipped business center, featuring computers, a printer, and ample workspace for all your needs.",
      "link": "false",
      "alt_text": "Business center with computers, printer, and desks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BusinessCenter.jpg"
    },
    {
      "id": "ec_1b7111cd06c6be48c278bfb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f973-7113-927e-d5409c516d69.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, exercise balls, and cardio equipment.",
        "public_id": "019d4a39-f973-7113-927e-d5409c516d69",
        "storage_key": "property/6767906449166908/019d4a39-f973-7113-927e-d5409c516d69.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active and healthy in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, free weights, exercise balls, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_FitnessCenterEquipment.jpg"
    },
    {
      "id": "ec_e139fa56049b9c5e657bccf9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-fc37-73bb-9c6c-c4a81333221a.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, exercise balls, resistance bands, and stationary bikes.",
        "public_id": "019d4a39-fc37-73bb-9c6c-c4a81333221a",
        "storage_key": "property/6767906449166908/019d4a39-fc37-73bb-9c6c-c4a81333221a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a variety of cardio machines, weight training equipment, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, exercise balls, resistance bands, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_FitnessCenterStrengthTraining.jpg"
    },
    {
      "id": "ec_ee5c22e0aab81c5a1d596ce4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-57f1-7501-b8ee-4fa57600908d.webp",
      "image_media": {
        "alt_text": "Rack of dumbbells and weight machines in apartment gym.",
        "public_id": "019d4a39-57f1-7501-b8ee-4fa57600908d",
        "storage_key": "property/6767906449166908/019d4a39-57f1-7501-b8ee-4fa57600908d.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Fitness center with a variety of free weights and cardio machines.",
      "link": "false",
      "alt_text": "Rack of dumbbells and weight machines in apartment gym.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_FitnessCenterFreeWeights.jpg"
    },
    {
      "id": "ec_84091a074639f1fb89881fbc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f97f-768e-b7a5-599a9926f7da.webp",
      "image_media": {
        "alt_text": "Treadmill in the apartment complex gym",
        "public_id": "019d4a39-f97f-768e-b7a5-599a9926f7da",
        "storage_key": "property/6767906449166908/019d4a39-f97f-768e-b7a5-599a9926f7da.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Workout on a state-of-the-art treadmill in our fully equipped fitness center.",
      "link": "false",
      "alt_text": "Treadmill in the apartment complex gym",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_FitnessCenterCardio.jpg"
    },
    {
      "id": "ec_84333d8ecc391745a88c7003",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-70e8-727f-ac09-8abefdad6860.webp",
      "image_media": {
        "alt_text": "Hot tub with bubbling water and safety signs.",
        "public_id": "019d4a39-70e8-727f-ac09-8abefdad6860",
        "storage_key": "property/6767906449166908/019d4a39-70e8-727f-ac09-8abefdad6860.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Community",
      "description": "Enjoy a relaxing soak in the community hot tub, open 24 hours for your convenience. Please observe all posted spa rules.",
      "link": "false",
      "alt_text": "Hot tub with bubbling water and safety signs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_Spa.jpg"
    },
    {
      "id": "ec_d38ccaae409459c39c5a511f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f970-713d-9ea1-5f382234c38f.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d4a39-f970-713d-9ea1-5f382234c38f",
        "storage_key": "property/6767906449166908/019d4a39-f970-713d-9ea1-5f382234c38f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, complete with comfortable lounge chairs and shaded umbrellas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_SwimmingPool2.jpg"
    },
    {
      "id": "ec_0295fffb45a157dc4caf3d16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a39-f980-7060-be8b-73473bd0fc68.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d4a39-f980-7060-be8b-73473bd0fc68",
        "storage_key": "property/6767906449166908/019d4a39-f980-7060-be8b-73473bd0fc68.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_SwimmingPool1.jpg"
    },
    {
      "id": "ec_b5977425cbbfda582ce2d13c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f347-744f-a747-702aec666a3d.webp",
      "image_media": {
        "alt_text": "Sunny outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019d4a3a-f347-744f-a747-702aec666a3d",
        "storage_key": "property/6767906449166908/019d4a3a-f347-744f-a747-702aec666a3d.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for a perfect day of leisure.",
      "link": "false",
      "alt_text": "Sunny outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_SwimmingPoolFurniture.jpg"
    },
    {
      "id": "ec_7513c261394f563bbe1843cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f3b8-7142-9ae8-13269d2ac784.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment, a tunnel, and benches.",
        "public_id": "019d4a3a-f3b8-7142-9ae8-13269d2ac784",
        "storage_key": "property/6767906449166908/019d4a3a-f3b8-7142-9ae8-13269d2ac784.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our fenced dog park, complete with agility equipment, tunnels, and benches for your furry friends.",
      "link": "false",
      "alt_text": "Fenced dog park with agility equipment, a tunnel, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BarkParkExterior.jpg"
    },
    {
      "id": "ec_c007bd5a2995daa822ea4af2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f6c5-7240-b306-a0609c7aaed4.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment including a tunnel and ramp.",
        "public_id": "019d4a3a-f6c5-7240-b306-a0609c7aaed4",
        "storage_key": "property/6767906449166908/019d4a3a-f6c5-7240-b306-a0609c7aaed4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and exercise in a safe, enclosed environment with agility equipment.",
      "link": "false",
      "alt_text": "Dog park area with agility equipment including a tunnel and ramp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BarkParkInterior.jpg"
    },
    {
      "id": "ec_c037a7d23b07ca1066a4663d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f40b-72c2-813b-ad4c13cba8ca.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with landscaping and walkway.",
        "public_id": "019d4a3a-f40b-72c2-813b-ad4c13cba8ca",
        "storage_key": "property/6767906449166908/019d4a3a-f40b-72c2-813b-ad4c13cba8ca.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of apartment building showing the building's facade, exterior stairwell, and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with landscaping and walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BuildingExteriors1.jpg"
    },
    {
      "id": "ec_9f5a9444b7879bdaabc51811",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3a-f3a0-726d-8c3c-efc7c095a701.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with stairs and landscaping.",
        "public_id": "019d4a3a-f3a0-726d-8c3c-efc7c095a701",
        "storage_key": "property/6767906449166908/019d4a3a-f3a0-726d-8c3c-efc7c095a701.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring stairs, manicured landscaping, and lush green grass.",
      "link": "false",
      "alt_text": "Apartment building exterior with stairs and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BuildingExteriors2.jpg"
    },
    {
      "id": "ec_eb9a0549ee7054813f30f373",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3c-0c26-733e-959c-cc4d8f65b062.webp",
      "image_media": {
        "alt_text": "Path leading through manicured landscaping to apartment buildings.",
        "public_id": "019d4a3c-0c26-733e-959c-cc4d8f65b062",
        "storage_key": "property/6767906449166908/019d4a3c-0c26-733e-959c-cc4d8f65b062.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Explore the beautifully landscaped grounds featuring blooming flowers and mature trees, with a walking path leading to the apartment buildings.",
      "link": "false",
      "alt_text": "Path leading through manicured landscaping to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_BuildingExteriorSidewalks.jpg"
    },
    {
      "id": "ec_660d9a84513e9ef0e2f8a353",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3c-0c85-7558-83db-140fbcdd830b.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with natural landscaping and large rocks.",
        "public_id": "019d4a3c-0c85-7558-83db-140fbcdd830b",
        "storage_key": "property/6767906449166908/019d4a3c-0c85-7558-83db-140fbcdd830b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with large boulders and mature trees surround the apartment buildings, offering a serene living environment.",
      "link": "false",
      "alt_text": "Apartment building exterior with natural landscaping and large rocks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Stanford Heights Apartments Landscaping boulders.jpg"
    },
    {
      "id": "ec_99336fe8fff6de7420267c9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d4a3c-0c24-72ab-802c-a452546db48f.webp",
      "image_media": {
        "alt_text": "Exterior view of a building with multiple white garage doors.",
        "public_id": "019d4a3c-0c24-72ab-802c-a452546db48f",
        "storage_key": "property/6767906449166908/019d4a3c-0c24-72ab-802c-a452546db48f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Secure garage parking available for residents.",
      "link": "false",
      "alt_text": "Exterior view of a building with multiple white garage doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/StanfordHeights_Rocklin_CA_Garages(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7775b264-4fdc-46d7-9379-3a8beade845c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-d536-773a-9eeb-a8fc425501dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-d536-773a-9eeb-a8fc425501dc",
        "storage_key": "property/6767906449166908/019d08b0-d536-773a-9eeb-a8fc425501dc.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0bd-7044-984e-dfbe7401f9b5",
        "storage_key": "property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1d02e6ac-bb0c-42a3-9103-fe8bc72fbf19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-d84c-708f-b4ee-5d99f65e12ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-d84c-708f-b4ee-5d99f65e12ed",
        "storage_key": "property/6767906449166908/019d08b0-d84c-708f-b4ee-5d99f65e12ed.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0bd-7044-984e-dfbe7401f9b5",
        "storage_key": "property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_c4bd83d0-5bf4-4be4-8a58-925b63fbdea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-d4ee-72a9-bc26-c4daade74959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-d4ee-72a9-bc26-c4daade74959",
        "storage_key": "property/6767906449166908/019d08b0-d4ee-72a9-bc26-c4daade74959.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0bd-7044-984e-dfbe7401f9b5",
        "storage_key": "property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_22305459-8f27-4da5-9c99-c25b606b3ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-d4b3-703d-82b1-b7ed32494ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-d4b3-703d-82b1-b7ed32494ac5",
        "storage_key": "property/6767906449166908/019d08b0-d4b3-703d-82b1-b7ed32494ac5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0bd-7044-984e-dfbe7401f9b5",
        "storage_key": "property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_69648dc7-8b91-4973-921b-76a19bd7ec37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-de47-728e-a2df-dbc30f5007da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-de47-728e-a2df-dbc30f5007da",
        "storage_key": "property/6767906449166908/019d08b0-de47-728e-a2df-dbc30f5007da.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0bd-7044-984e-dfbe7401f9b5",
        "storage_key": "property/6767906449166908/019d08b0-b0bd-7044-984e-dfbe7401f9b5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_99c47e9e-2a98-4076-8055-93818a80201d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-dec8-7716-982b-5acc53356a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-dec8-7716-982b-5acc53356a8c",
        "storage_key": "property/6767906449166908/019d08b0-dec8-7716-982b-5acc53356a8c.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b66f-7739-874e-54595067a6dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b66f-7739-874e-54595067a6dd",
        "storage_key": "property/6767906449166908/019d08b0-b66f-7739-874e-54595067a6dd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_98e2a2e7-e737-425c-b5a5-29d267cef458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-e1a6-7058-a4ce-7e44e19d9f8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e1a6-7058-a4ce-7e44e19d9f8f",
        "storage_key": "property/6767906449166908/019d08b0-e1a6-7058-a4ce-7e44e19d9f8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b4-7087-bc26-62265d483b86",
        "storage_key": "property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3cb1138e-8b2c-4f50-8ef5-78ffb1683d22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-e1a7-75b0-a20f-f0d8a8a67ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e1a7-75b0-a20f-f0d8a8a67ee6",
        "storage_key": "property/6767906449166908/019d08b0-e1a7-75b0-a20f-f0d8a8a67ee6.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b4-7087-bc26-62265d483b86",
        "storage_key": "property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a0b37d67-0d57-46da-bbbf-cb03a4535e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-e84f-70cf-ac9b-1986fb069536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e84f-70cf-ac9b-1986fb069536",
        "storage_key": "property/6767906449166908/019d08b0-e84f-70cf-ac9b-1986fb069536.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b4-7087-bc26-62265d483b86",
        "storage_key": "property/6767906449166908/019d08b0-b0b4-7087-bc26-62265d483b86.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2ce17c3c-8aad-49f1-919d-bcffeadd1f0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-e8d1-761e-8998-27b4c3cf439a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e8d1-761e-8998-27b4c3cf439a",
        "storage_key": "property/6767906449166908/019d08b0-e8d1-761e-8998-27b4c3cf439a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b66f-7739-874e-54595067a6dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b66f-7739-874e-54595067a6dd",
        "storage_key": "property/6767906449166908/019d08b0-b66f-7739-874e-54595067a6dd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7fc4151c-fc2c-4f16-9dac-1436fe3cc079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-9a78-7349-acc2-a510eb661074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-9a78-7349-acc2-a510eb661074",
        "storage_key": "property/6767906449166908/019d08b0-9a78-7349-acc2-a510eb661074.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b766-7158-ae25-e17a53833256.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b766-7158-ae25-e17a53833256",
        "storage_key": "property/6767906449166908/019d08b0-b766-7158-ae25-e17a53833256.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_05546468-bb5e-4890-8a77-683026e1c156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-517c-735e-96f5-0160a6002e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-517c-735e-96f5-0160a6002e1e",
        "storage_key": "property/6767906449166908/019d08b0-517c-735e-96f5-0160a6002e1e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b766-7158-ae25-e17a53833256.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b766-7158-ae25-e17a53833256",
        "storage_key": "property/6767906449166908/019d08b0-b766-7158-ae25-e17a53833256.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5d7dc450-9ebc-4670-8876-148d5cc172f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-55ce-77cc-9b9c-f50c89e889d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-55ce-77cc-9b9c-f50c89e889d7",
        "storage_key": "property/6767906449166908/019d08b0-55ce-77cc-9b9c-f50c89e889d7.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_2e034a1a-8924-4742-ab4c-af0c26a49b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-ed38-71e8-bab3-81e5878c6c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-ed38-71e8-bab3-81e5878c6c92",
        "storage_key": "property/6767906449166908/019d08b0-ed38-71e8-bab3-81e5878c6c92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_dc5933a6-2e60-4138-8a43-8a6152ac7837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-8db0-758a-9ee3-5c75c4200cf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-8db0-758a-9ee3-5c75c4200cf5",
        "storage_key": "property/6767906449166908/019d08b0-8db0-758a-9ee3-5c75c4200cf5.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-bc23-7549-95ba-f39cdb786330",
        "storage_key": "property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8cef5d67-aaaa-4606-b8bc-f2b978a191c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-5cc6-7339-8f2b-edba3a8efc90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-5cc6-7339-8f2b-edba3a8efc90",
        "storage_key": "property/6767906449166908/019d08b0-5cc6-7339-8f2b-edba3a8efc90.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-bc23-7549-95ba-f39cdb786330",
        "storage_key": "property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b352995c-14d8-4a83-b472-2604b5d27079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Roseville Utility Exploration Center",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_long_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-f2cc-77fd-9292-28f8bb9035f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f2cc-77fd-9292-28f8bb9035f3",
        "storage_key": "property/6767906449166908/019d08b0-f2cc-77fd-9292-28f8bb9035f3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.roseville.ca.us/explore",
      "poi_directions_map_url": "https://maps.google.com/?cid=910903833852852384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-utility-exploration-center",
      "poi_latitude": "38.7674387",
      "poi_longitude": "-121.332085",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-746-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-bc23-7549-95ba-f39cdb786330",
        "storage_key": "property/6767906449166908/019d08b0-bc23-7549-95ba-f39cdb786330.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8ooIkAhm4ARoDhX8TUupAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e1a3448a-75a8-4383-b650-1613b34209e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-f375-701c-908c-9a28fe3526c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f375-701c-908c-9a28fe3526c8",
        "storage_key": "property/6767906449166908/019d08b0-f375-701c-908c-9a28fe3526c8.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e1e73ea8-092d-4f51-b70e-1748a49926fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1533 Blue Oaks Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Clean 24-hour fitness center offering weight training and cardio machines, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, machines, and classes, including Zumba, and has amenities like a sauna, cold plunge, and hot tub. They also highlight the friendly, energetic, and supportive staff, and the positive and motivating vibe.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-f42b-748b-bfb0-ac93a853394f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f42b-748b-bfb0-ac93a853394f",
        "storage_key": "property/6767906449166908/019d08b0-f42b-748b-bfb0-ac93a853394f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/west-roseville-super-sport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961004575732605694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7936837",
      "poi_longitude": "-121.3276887",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 279-399-7106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ag-VlIjm4AR_iJp2Md0mmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_295177ae-f63d-4036-b4aa-85a98a0df2f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-fb90-71da-b2a7-adf8ea055d83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-fb90-71da-b2a7-adf8ea055d83",
        "storage_key": "property/6767906449166908/019d08b0-fb90-71da-b2a7-adf8ea055d83.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f30170a9-e759-445b-bc2b-6b6cc38f1145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6831 Lonetree Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain gym with cardio and strength-training equipment, massage chairs, tanning beds, and showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-7223-7355-84c4-23239417d8eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-7223-7355-84c4-23239417d8eb",
        "storage_key": "property/6767906449166908/019d08b0-7223-7355-84c4-23239417d8eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/rocklin-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10254324074506971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7976671",
      "poi_longitude": "-121.2899537",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-755-6015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4x-sEZojm4ARfGq5gGqtTo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_66aa3323-4ced-4462-bb72-909a0f937c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "VCA Loomis Basin Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Sierra College Blvd, Loomis, CA 95650, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-fdda-710d-a422-bb434f048b23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-fdda-710d-a422-bb434f048b23",
        "storage_key": "property/6767906449166908/019d08b0-fdda-710d-a422-bb434f048b23.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/loomis-basin?utm_source=maps&utm_medium=organic&utm_campaign=AU_935",
      "poi_directions_map_url": "https://maps.google.com/?cid=3050520726901175039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-loomis-basin-veterinary-clinic",
      "poi_latitude": "38.81533",
      "poi_longitude": "-121.207103",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-652-5816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-uKVdAem4AR_zLpUnCgVSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e2a9f2a1-0c53-406c-8e87-43de6a7345c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-fdda-710d-a422-b482ca0c9923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-fdda-710d-a422-b482ca0c9923",
        "storage_key": "property/6767906449166908/019d08b0-fdda-710d-a422-b482ca0c9923.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_55570d29-bf2e-45f6-9627-185183d3c34c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the gym is a decent size and the front desk staff is usually friendly. They also like the welcoming atmosphere and the willingness of members to share advice. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-fe03-71a8-8652-b1302c0e9fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-fe03-71a8-8652-b1302c0e9fdf",
        "storage_key": "property/6767906449166908/019d08b0-fe03-71a8-8652-b1302c0e9fdf.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4de02b65-e1b2-44cb-8223-3fa65dac2989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large variety of equipment, a pool, a sauna, and a steam room. They also highlight the friendly staff, the beautiful views, and the good vibe.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-05a1-7788-96ef-5670434a5aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-05a1-7788-96ef-5670434a5aae",
        "storage_key": "property/6767906449166908/019d08b1-05a1-7788-96ef-5670434a5aae.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2dd5c5b0-ab4c-47f0-b1c4-756b816756a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-67bc-7552-89cf-c1a9ee89a3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-67bc-7552-89cf-c1a9ee89a3e9",
        "storage_key": "property/6767906449166908/019d08b0-67bc-7552-89cf-c1a9ee89a3e9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-bc51-7180-9559-83216ee56371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-bc51-7180-9559-83216ee56371",
        "storage_key": "property/6767906449166908/019d08b0-bc51-7180-9559-83216ee56371.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c75208b7-23e2-42fd-ae4e-6a97a419ea7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-07c0-757c-9f96-97561c5f6154.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-07c0-757c-9f96-97561c5f6154",
        "storage_key": "property/6767906449166908/019d08b1-07c0-757c-9f96-97561c5f6154.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-bc51-7180-9559-83216ee56371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-bc51-7180-9559-83216ee56371",
        "storage_key": "property/6767906449166908/019d08b0-bc51-7180-9559-83216ee56371.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6954c3cf-53c4-4692-8df9-047c5edb2c07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-09a3-7692-9221-72af4a355ccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-09a3-7692-9221-72af4a355ccf",
        "storage_key": "property/6767906449166908/019d08b1-09a3-7692-9221-72af4a355ccf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-beda-744f-8c7d-d6a9286c67f4",
        "storage_key": "property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83a19456-fe89-4ccc-ad00-88da0e97b034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-09c2-77ae-b891-c6e0c9dabb25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-09c2-77ae-b891-c6e0c9dabb25",
        "storage_key": "property/6767906449166908/019d08b1-09c2-77ae-b891-c6e0c9dabb25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-beda-744f-8c7d-d6a9286c67f4",
        "storage_key": "property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3670b166-407b-4de5-91e6-812881ca1b9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-0e41-751b-8c6a-2f93dd9cf825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-0e41-751b-8c6a-2f93dd9cf825",
        "storage_key": "property/6767906449166908/019d08b1-0e41-751b-8c6a-2f93dd9cf825.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-beda-744f-8c7d-d6a9286c67f4",
        "storage_key": "property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c9283e57-0fea-47ce-8e70-54bcc35b4cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Mahany Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1545 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_long_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-111d-74d0-90d2-8ef7f56e243c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-111d-74d0-90d2-8ef7f56e243c",
        "storage_key": "property/6767906449166908/019d08b1-111d-74d0-90d2-8ef7f56e243c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7614086073060341684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mahany-park",
      "poi_latitude": "38.7674183",
      "poi_longitude": "-121.3341323",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-beda-744f-8c7d-d6a9286c67f4",
        "storage_key": "property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp32Y_0Ahm4ARtLcCOvGqqmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fd43a236-02cc-4820-87c6-e64f638c1e35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Royer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "190 Park Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Home to the Children's Art Center, the space also has picnic & play areas as well as horseshoe pits.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, basketball courts, tennis courts, and walking paths. They highlight the park's clean and well-maintained facilities, as well as the abundance of shade and green spaces. They also like the peaceful and relaxing atmosphere, and the family-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-12a7-77cd-9f6b-13ccb4fc901e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-12a7-77cd-9f6b-13ccb4fc901e",
        "storage_key": "property/6767906449166908/019d08b1-12a7-77cd-9f6b-13ccb4fc901e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/royer_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=438860327728013116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "royer-park",
      "poi_latitude": "38.7459127",
      "poi_longitude": "-121.2828289",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-beda-744f-8c7d-d6a9286c67f4",
        "storage_key": "property/6767906449166908/019d08b0-beda-744f-8c7d-d6a9286c67f4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ090SHT8gm4ARPF89lCQlFwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7d830968-4b00-46b6-b2f4-dd6c1e27c1de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-a056-771b-aa1d-3d7e5a46abfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-a056-771b-aa1d-3d7e5a46abfd",
        "storage_key": "property/6767906449166908/019d08b0-a056-771b-aa1d-3d7e5a46abfd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_56552118-dac8-4ff7-8ab9-c6fd370b40a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-a016-71db-9ebc-dcd797941655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-a016-71db-9ebc-dcd797941655",
        "storage_key": "property/6767906449166908/019d08b0-a016-71db-9ebc-dcd797941655.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e17ac2a5-ce98-4028-9f02-f6c99007979f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_87a2d1a0-db7b-4783-a48e-1e572faacfaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a7fff9f6-899c-47ac-b7cc-226f5df7b0db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "poi_name": "WSI Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3750 Atherton Rd, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b1-1529-7427-b5e2-75540231e9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-1529-7427-b5e2-75540231e9ca",
        "storage_key": "property/6767906449166908/019d08b1-1529-7427-b5e2-75540231e9ca.webp",
        "width": 574,
        "height": 574
      },
      "poi_business_url": "http://www.williams-sonomainc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374488400562628873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsi-corporate-office",
      "poi_latitude": "38.8164424",
      "poi_longitude": "-121.2953052",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 415-421-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-b0b6-70b0-a9c4-c7f6f61f2102",
        "storage_key": "property/6767906449166908/019d08b0-b0b6-70b0-a9c4-c7f6f61f2102.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfctaUcim4ARCSmCfwpxfMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_99ed2d96-b1a0-4b60-bd07-01e8f70a5f18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9dd0acc6-f97d-4f2a-90df-e9c5a6cd2798",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_d4d6b63e-eac4-4399-aa5d-069030729c41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_990d4fd5-03f6-4850-990d-0144abfe44cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_28963049-cdd3-42e4-b6ec-b67d2c38c942",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_c7345fc9-25ab-44ff-aa4c-afc780d29849",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_da91955c-0bca-4fc6-8651-c4d9b3695bd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "rating": "5.0",
      "name": "aniko nelson",
      "text": "We have been here since November, nearly 7 months and previously in a different apartment complex for 3 years. This is the fastest we have ever received maintenance requests being serviced. Since we've moved in our garbage disposal stopped working, our kitchen light went out and our duct to the dryer fell off. This was no problem because they had maintenance out right away and was so accommodating, and everything was fixed quickly. The neighborhood is quiet, nicely taken care of, and dog friendly. They have had Christmas and halloween treats residents can pick up at the office. All of these things have made our experience so delightful. We hope to be stay here long and continue to live in a complex as nice as this!  Thank you Stanford Heights its been such a good experience for us thus far! We look forward to living life here longer and if you can say that about a apartment then you are winning!",
      "date": "2025-05-21",
      "title": ""
    },
    {
      "id": "custom_70bf2713-c99d-4862-91cb-1e3fdb1ffbec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "rating": "5.0",
      "name": "Jenn Treleaven",
      "text": "We’ve lived here a couple years now and have nearly 0 complaints. Units are nice, maintenance is fast, friendly and helpful, management is relaxed, neighbors are cool.\n\nWe also feel that rent is fairly priced. Others have noted seeing rats, but I’ve never seen one on the property.",
      "date": "2025-07-06",
      "title": ""
    },
    {
      "id": "custom_e61beb74-ebf6-409d-af93-620e5f5271ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "rating": "5.0",
      "name": "Natalie Perez",
      "text": "My family of 4 moved here from Fresno last July 17’ and have really enjoyed living here. It’s such a great community. The staff is on top of things. When I request/service is needed in the apartment the maintenance crew is on it right away. Not that we need them all time either. Because everything works well. This place has beautiful landscapes and quite neighbors. I love how close it is to the park and elementary school and walking distance to grocery stores and restaurants. It’s a great place for families. 1, 2, and 3 bedrooms. Nice options and layouts. We love it here!!!",
      "date": "2018-07-23",
      "title": ""
    },
    {
      "id": "custom_07db8fa0-8852-4847-ab45-c4f6ff590dfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "rating": "5.0",
      "name": "Daniel Brown",
      "text": "My favorite thing here is that the apartments, bedrooms & closets are very large at a very reasonable price; you get more space for the money than most I looked at. Neighbors are very nice. Lot's of tall trees make the grounds very scenic and provide shade in the summer. Management is tough but fair, they'll work with you as much as they can one resolving problems, we've had a great relationship. Pool & gym are nice, I appreciate that they spent the extra money on really nice gym equipment. There's a great park 1 block away, both my dog and grand kids love it. Grocery stores & shopping are also 1 block away so you don't really need a car to live here. Stanford Heights is definitely the best place in Rocklin.",
      "date": "2018-07-23",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_23793092-ff3f-4ef1-9cb3-cc7a6b526575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-5846-769a-bcdb-766f0f73db5e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-5846-769a-bcdb-766f0f73db5e",
        "storage_key": "property/6767906449166908/019d3163-5846-769a-bcdb-766f0f73db5e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 1 Bedroom 1 Bath 623 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FuuBRsy64Kd"
    },
    {
      "id": "custom_95b60a8f-da07-44e3-8c29-2f575d1ad6ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-70a6-7572-94b1-9b3cdc967ab3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-70a6-7572-94b1-9b3cdc967ab3",
        "storage_key": "property/6767906449166908/019d3163-70a6-7572-94b1-9b3cdc967ab3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 1 Bedroom 1 Bath 813 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jpZqNYN7XD6"
    },
    {
      "id": "custom_5fd2ad02-ea0f-470c-aa95-225961f64bc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-820a-720e-8d6e-d1993f3a83ad.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-820a-720e-8d6e-d1993f3a83ad",
        "storage_key": "property/6767906449166908/019d3163-820a-720e-8d6e-d1993f3a83ad.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 2 Bedroom 1 Bath 852 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cxf8cpQazGo"
    },
    {
      "id": "custom_4201d67c-17f3-4e31-b8c1-c90b5f26a47f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-9771-7648-a089-e70767c405ae.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-9771-7648-a089-e70767c405ae",
        "storage_key": "property/6767906449166908/019d3163-9771-7648-a089-e70767c405ae.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 2 Bedroom 1 Bath 985 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=b7MG3JBxa2k"
    },
    {
      "id": "custom_ef58402f-54c8-4459-a89a-2c1f98709397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-af8b-716d-9585-95c74a8bcba7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-af8b-716d-9585-95c74a8bcba7",
        "storage_key": "property/6767906449166908/019d3163-af8b-716d-9585-95c74a8bcba7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 2 Bedroom 2 Bath 877 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qEguv6Hk9u1"
    },
    {
      "id": "custom_3e810b36-b7e0-4857-9213-41f13b6f8111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-c6b0-72c7-9813-30bc6ea6d3eb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-c6b0-72c7-9813-30bc6ea6d3eb",
        "storage_key": "property/6767906449166908/019d3163-c6b0-72c7-9813-30bc6ea6d3eb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 2 Bedroom 2 Bath 969 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=W7aeGDfrKLL"
    },
    {
      "id": "custom_49239a63-424c-4e81-a111-471593627729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-dbb5-708f-9ada-f97e0a6dc074.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-dbb5-708f-9ada-f97e0a6dc074",
        "storage_key": "property/6767906449166908/019d3163-dbb5-708f-9ada-f97e0a6dc074.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 2 Bedroom 2 Bath 1101 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x4bUssYy5G5"
    },
    {
      "id": "custom_cbc5bf63-3892-459e-97f1-7bd38ee547f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3163-f1be-714d-ab93-9f51d2c364c3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3163-f1be-714d-ab93-9f51d2c364c3",
        "storage_key": "property/6767906449166908/019d3163-f1be-714d-ab93-9f51d2c364c3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 3 Bedroom 2 Bath 1,022 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7UMW2UQsgYW"
    },
    {
      "id": "custom_1f9af2df-bdb7-42f5-8d7e-58efe0e082f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3164-05cd-70cd-bb55-7e206140a217.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3164-05cd-70cd-bb55-7e206140a217",
        "storage_key": "property/6767906449166908/019d3164-05cd-70cd-bb55-7e206140a217.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - 3 Bedroom 2 Bath 1185 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XPtNWekNvUw"
    },
    {
      "id": "custom_90dccb84-2a01-4704-84ac-96a317f2b3fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3164-2fd7-7067-9e1a-2952bd3ba030.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3164-2fd7-7067-9e1a-2952bd3ba030",
        "storage_key": "property/6767906449166908/019d3164-2fd7-7067-9e1a-2952bd3ba030.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=G24F1zur1dA"
    },
    {
      "id": "custom_3ccfdd32-fbc5-4c2b-b2df-b965d7afe513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166908/019d3164-461b-72a9-9835-9e0c695b478a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3164-461b-72a9-9835-9e0c695b478a",
        "storage_key": "property/6767906449166908/019d3164-461b-72a9-9835-9e0c695b478a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Stanford Heights Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2GynoYod4Un"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c1-70a4-732e-96d7-4a03b64ee6d2",
      "lead_source": "LANDING_PAGE",
      "name": "Stanford Heights Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-apartments-in-unit-laundry-rocklin-ca",
      "search_query": "apartments with in-unit laundry in Rocklin CA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Rocklin, CA",
      "h2_subtitle": "Looking for apartments with in-unit laundry? Discover comfortable living with in-unit laundry at Stanford Heights in Rocklin, CA.",
      "page_copy": "Experience the perfect blend of convenience and comfort at Stanford Heights, where we offer apartments with in-unit laundry in Rocklin, CA. Our vibrant community not only provides you with modern amenities like a basketball court and patio but also ensures that laundry day is a breeze with the convenience of having laundry facilities in your own unit.\n\nLocated in Rocklin, home to picturesque landscapes and planned social activities, Stanford Heights invites you to enjoy hassle-free living. Beyond in-unit laundry, revel in our engaging community events and take advantage of our online services designed to make your living experience seamless. Discover a perfect place to call home at Stanford Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Rocklin, CA",
      "seo_description": "Discover Stanford Heights apartments with in-unit laundry in Rocklin, CA. Enjoy comfort and convenience in a vibrant setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-dog-park-stanford-heights",
      "search_query": "dog-friendly apartments with dog park in Placer County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Dog Park",
      "h2_subtitle": "Find your perfect home at Stanford Heights, featuring dog-friendly apartments and a dog park for your furry friends in Placer County.",
      "page_copy": "Stanford Heights is the ideal choice for pet owners seeking dog-friendly apartments with a dog park in Placer County. Our inviting community is designed with pet lovers in mind, offering ample space and amenities for you and your furry companions. Let them run and play in our convenient dog park while you relax and enjoy the serene surroundings.\n\nSituated in picturesque Placer County, Stanford Heights combines the best of suburban charm with pet-friendly comforts. In addition to our dedicated dog park, you will find amenities such as a patio, basketball court, and engaging planned social activities. Come home to a welcoming community that caters to all members of your household, including the four-legged kind.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Dog Park",
      "seo_description": "Explore Stanford Heights in Placer County for dog-friendly apartments with a dog park, perfect for you and your furry companion.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-apartment-air-conditioning-rocklin",
      "search_query": "apartment with air conditioning near Rocklin 95765",
      "category": "Amenity",
      "h1_title": "Apartment with Air Conditioning near Rocklin",
      "h2_subtitle": "Stay cool and comfortable in an apartment with air conditioning right near Rocklin, 95765 at Stanford Heights.",
      "page_copy": "Experience the refreshing comfort of an apartment with air conditioning near Rocklin, 95765, at Stanford Heights. Our community ensures a cool escape from the California heat with air-conditioned living spaces, where you can unwind after a busy day.\n\nBeyond climate comfort, our Stanford Heights location offers a range of amenities including a convenient basketball court, engaging planned social activities, and access to online services. Embrace a lifestyle of ease and leisure, situated perfectly for those seeking the best of both community living and serene home environments in Rocklin.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Air Conditioning near Rocklin",
      "seo_description": "Find comfort in an apartment with air conditioning near Rocklin, 95765 at Stanford Heights. Enjoy modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-luxury-apartment-pool-rocklin",
      "search_query": "luxury apartment with pool in Rocklin CA",
      "category": "Amenity",
      "h1_title": "Luxury Apartment with Pool in Rocklin, CA",
      "h2_subtitle": "Discover luxury living at Stanford Heights, featuring a stunning pool in Rocklin, CA. Enjoy upscale amenities and an unmatched lifestyle.",
      "page_copy": "At Stanford Heights, we redefine upscale living with our luxury apartment featuring a sparkling pool, located in Rocklin, CA. Our residents enjoy not only the elegance and sophistication of high-end home features but also the leisure and relaxation of a beautifully maintained pool area.\n\nPositioned in the heart of Rocklin, Stanford Heights offers a lifestyle enriched with amenities such as planned social activities and easy access to online services. Feel pampered with convenient facilities and dedicated spaces designed for your comfort and enjoyment. Whether you're lounging by the pool or engaged in community happenings, elevate your living experience at our luxury apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartment with Pool in Rocklin, CA",
      "seo_description": "Indulge in a luxury apartment with a pool at Stanford Heights in Rocklin, CA. Enjoy premium amenities and a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-apartments-dishwasher-placer-county",
      "search_query": "apartments with dishwasher in Placer County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Placer County",
      "h2_subtitle": "Discover modern living at Stanford Heights, where our apartments feature dishwashers in the heart of Placer County.",
      "page_copy": "Welcome to Stanford Heights, where convenience meets style in Placer County. Our apartments come equipped with dishwashers, adding ease and efficiency to your daily routine. Experience modern living with kitchen appliances that save time and effort, allowing you to enjoy more of what life has to offer.\n\nLocated in the scenic settings of Placer County, Stanford Heights also provides impressive amenities including a basketball court, patio, and community-planned social activities. Embrace the charm of a welcoming community with modern conveniences to enhance your living experience. Explore the blend of comfort and efficiency at Stanford Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Placer County",
      "seo_description": "Discover apartments with dishwashers at Stanford Heights in Placer County. Enjoy modern conveniences in a charming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-1-bedroom-apartments-rocklin",
      "search_query": "1 bedroom apartments rocklin ca",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Rocklin, CA",
      "h2_subtitle": "Find your perfect 1-bedroom apartment at Stanford Heights in Rocklin, CA. Enjoy spacious layouts and modern amenities.",
      "page_copy": "Stanford Heights offers inviting 1-bedroom apartments in Rocklin, CA, designed for those seeking comfort, style, and convenience. Our thoughtfully laid-out floor plans provide the perfect retreat, combining ample space with modern touches. Whether you're a busy professional or looking for a cozy home, our apartments offer the ideal living experience.\n\nBeyond the welcoming interiors, Stanford Heights enhances your lifestyle with a wide array of amenities such as a basketball court, planned social activities, and private patios. Located in the vibrant community of Rocklin, CA, residents enjoy easy access to everything this delightful area offers. Discover the difference at Stanford Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Rocklin, CA",
      "seo_description": "Explore 1-bedroom apartments at Stanford Heights in Rocklin, CA. Spacious layouts and amenities create the perfect home environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-2-bedroom-apartments-placer-county",
      "search_query": "2 bedroom apartment stanford heights placer county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartment in Placer County",
      "h2_subtitle": "Explore 2-bedroom apartments at Stanford Heights, nestled in the charming Placer County. Perfect for families and professionals.",
      "page_copy": "Experience comfortable living at Stanford Heights with our spacious 2-bedroom apartments located in beautiful Placer County. Designed with modern finishes and generous layouts, these homes are ideal for both families and professionals seeking a bit more room to spread out.\n\nResidents of Stanford Heights enjoy access to quality amenities, including a basketball court and planned social activities, creating a community feel. The convenience of online services and a private patio further enhance the living experience. Embrace the tranquil setting and vibrant community life that Placer County offers, right here at Stanford Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartment in Placer County",
      "seo_description": "Discover spacious 2-bedroom apartments at Stanford Heights in Placer County. Perfect for families and professionals alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166908",
      "source": "generator",
      "page_item_url": "stanford-heights-3-bedroom-apartments-near-95765",
      "search_query": "3 bedroom apartments near 95765",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 95765",
      "h2_subtitle": "Find 3-bedroom apartments at Stanford Heights near the 95765 area. Perfect for families and roommates.",
      "page_copy": "Stanford Heights presents spacious 3-bedroom apartments conveniently located near the 95765 area, offering an ideal living choice for families and roommates alike. Our units feature ample living space and contemporary design, allowing for comfortable and stylish surroundings.\n\nResidents enjoy the added benefits of our community amenities, including a basketball court, private patios, and planned social activities, fostering a vibrant and active community. Nestled in Placer County, Stanford Heights offers easy access to local attractions and conveniences, making it a perfect place to call home near the 95765 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 95765",
      "seo_description": "Discover spacious 3-bedroom apartments at Stanford Heights near 95765. Ideal for families and roommates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5973"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372416172"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MKR3BW8V"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-561-1144 "
    }
  ],
  "custom_qb_id": "5973",
  "custom_repli_id": "18372416172",
  "custom_google_gtm_id": "GTM-MKR3BW8V",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-561-1144 "
};

export const generatedAt = '2026-09-23T19:54:41.995Z';
